import { DeviceCallLog } from '@iot-platform/models/common';
import { I4BGrid, I4BGridData, I4BGridOptions } from '@iot-platform/models/grid-engine';
import { Observable } from 'rxjs';

export abstract class AbstractDeviceCallLogsService {
  abstract getStaticGridDefinition(): Observable<I4BGrid<I4BGridOptions, I4BGridData> | null>;
  abstract onOpen(deviceCallLog: DeviceCallLog): void;
  abstract onDownloadMessage(deviceCallLog: DeviceCallLog): void;
}
